// UT_API's user-facing text is DisplayMessage or displayMessage depending on the endpoint,
// so check both. Message / message are skipped — they carry technical exception text (e.g.
// axios's own "Request failed with status code 400"), less useful than the caller's fallback.
// The fallback defaults to undefined on purpose: error dialogs (e.g. PopupV3) already supply
// their own default copy plus a "contact Support" line when the message is empty, and a
// generic string here would suppress that. Callers that render the message directly should
// pass an explicit fallback.
export const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    return data?.DisplayMessage ||
        data?.displayMessage ||
        fallback;
};
